const FacebookCircleIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="38" height="38" rx="19" fill="currentColor" />
        <path
          d="M21.8438 16.8412H19.9034V15.57C19.9034 15.0926 20.2212 14.9806 20.4438 14.9806H21.8102V12.882L19.9258 12.875C17.8356 12.875 17.361 14.4402 17.361 15.4426V16.8412H16.1514V19.0028H17.361V25.1236H19.9048V19.0042H21.6212L21.8438 16.8412Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default FacebookCircleIcon;
